import follow_ups from '../../api/follow_ups'
import i18n from "../../i18n";

// initial state
const state = {
    selectedFollowUp: {
        id: null,
        question: {
            completed: false,
            next_link: null,
            score_group_instructions: null,
            score_group_name: null,
            score_instructions: null,
            score_question_answer: null,
            score_question_text: null,
            progression: 0,
            total_questions: 0,
        }
    },
    concern: 'patient',
    resultFollowUp: {
        follow_up: {
            follow_up_definition: {
                name: '',
                follow_up_score_definitions: {}
            },
            follow_up_scores: null,
            treatment: {
                medical_case: {
                    diagnostic: {
                        type: null
                    }
                },
                type: null
            }
        }
    },
    nextUrl: null,
    lastUrl: null,
    completedNextUrl: null,
    hasRelatedTreatmentWithFollowupDone: false,
    followUpStep: null,
    followUpName: null,
    medicalCaseName: null,
    followUpStatus: null,
    copyRelatedUrl: null

    /*selectedTreatment: {
        id: null,
        type: null,
        description: null,
        medical_case: {
            diagnostic: {
                type: null
            }
        }
    },
    showForm: false*/
}

// getters
const getters = {}

// actions
const actions = {

    createFollowUp({state, commit, rootState}, payload) {
        return new Promise((resolve, reject) => {
            follow_ups.createFollowUp(rootState.patients.selectedPatient.id, rootState.medical_cases.selectedMedicalCase.id, rootState.treatments.selectedTreatment.id, payload, rootState.axios).then(result => {
                /*                commit('notifications/showSuccess', {
                                    title: success.CREATE_FOLLOWUP_SUCCESS.title, content: success.CREATE_FOLLOWUP_SUCCESS.content
                                }, {root: true})*/
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.CREATE_FOLLOWUP_ERROR'), content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    generateSignedUrl({state, commit, rootState}, payload) {

        return new Promise((resolve, reject) => {
            follow_ups.generateSignedUrl(rootState.patients.selectedPatient.id, rootState.medical_cases.selectedMedicalCase.id, rootState.treatments.selectedTreatment.id, payload.followUpDefinition, payload.concern, rootState.axios).then(result => {
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.CREATE_FOLLOWUP_ERROR'), content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    openFollowUpFromNotification({commit, rootState}, payload) {
        return new Promise((resolve, reject) => {
            follow_ups.createFollowUpFromNotification(rootState.treatments.selectedTreatment.id, state.followUpStep, payload.concern, payload.signature, payload.axios).then(result => {
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.CREATE_FOLLOWUP_ERROR'), content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    copyFollowUpFromNotification({commit, rootState}, payload) {
        return new Promise((resolve, reject) => {
            follow_ups.copyFollowUpFromNotification(state.copyRelatedUrl, payload.axios).then(result => {
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.COPY_FOLLOWUP_ERROR'), content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    getQuestion({state, commit, rootState}) {
        return new Promise((resolve, reject) => {
            follow_ups.next(rootState.patients.selectedPatient.id, rootState.medical_cases.selectedMedicalCase.id, rootState.treatments.selectedTreatment.id, rootState.follow_ups.selectedFollowUp.id, rootState.follow_ups.concern, rootState.axios).then(result => {
                commit('setQuestion', result.data.follow_up)
                resolve(result)
            }).catch(reason => {
                if (reason.response.data.status !== 'redirect') {
                    commit('notifications/showError', {
                        title: i18n.t('errors.GET_FOLLOWUP_LOADING_ERROR'), content: reason
                    }, {root: true})
                }
                reject(reason)
            })
        })
    },
    getQuestionFromNotification({state, commit, rootState}) {
        return new Promise((resolve, reject) => {
            follow_ups.nextFromNotification(state.nextUrl, rootState.axios).then(result => {
                commit('setQuestion', result.data.follow_up)
                resolve(result)
            }).catch(reason => {
                if (reason.response.data.status !== 'redirect') {
                    commit('notifications/showError', {
                        title: i18n.t('errors.GET_FOLLOWUP_LOADING_ERROR'), content: reason
                    }, {root: true})
                }
                reject(reason)
            })
        })
    },
    removeLastAnswer({state, commit, rootState}) {
        return new Promise((resolve, reject) => {
            follow_ups.removeLast(rootState.patients.selectedPatient.id, rootState.medical_cases.selectedMedicalCase.id, rootState.treatments.selectedTreatment.id, rootState.follow_ups.selectedFollowUp.id, rootState.follow_ups.concern, rootState.axios).then(result => {
                commit('setQuestion', result.data.follow_up)
                resolve(result)
            }).catch(reason => {
                if (reason.response.data.status !== 'redirect') {
                    commit('notifications/showError', {
                        title: i18n.t('errors.GET_FOLLOWUP_LOADING_ERROR'), content: reason
                    }, {root: true})
                }
                reject(reason)
            })
        })
    },
    removeLastAnswerFromNotification({state, commit, rootState}) {
        return new Promise((resolve, reject) => {
            follow_ups.removeLastFromNotification(state.lastUrl, rootState.axios).then(result => {
                commit('setQuestion', result.data.follow_up)
                resolve(result)
            }).catch(reason => {
                if (reason.response.data.status !== 'redirect') {
                    commit('notifications/showError', {
                        title: i18n.t('errors.GET_FOLLOWUP_LOADING_ERROR'), content: reason
                    }, {root: true})
                }
                reject(reason)
            })
        })
    },
    updateQuestion({state, commit, rootState}, payload) {
        return new Promise((resolve, reject) => {
            follow_ups.update(rootState.patients.selectedPatient.id, rootState.medical_cases.selectedMedicalCase.id, rootState.treatments.selectedTreatment.id, rootState.follow_ups.selectedFollowUp.id, payload, rootState.axios).then(result => {
                if (!result.data.follow_up.completed) {
                    commit('setQuestion', result.data.follow_up)
                } else {

                }
                commit('notifications/showSuccess', {
                    title: i18n.t('success.UPDATE_FOLLOWUP_SUCCESS.title'), content: i18n.t('success.UPDATE_FOLLOWUP_SUCCESS.content')
                }, {root: true})
                resolve(result)
            }).catch(reason => {
                if (reason.response.data.status !== 'redirect') {
                    commit('notifications/showError', {
                        title: i18n.t('errors.UPDATE_FOLLOWUP_ERROR'), content: reason
                    }, {root: true})
                }
                reject(reason)
            })
        })
    },
    updateQuestionFromNotification({state, commit, rootState}, payload) {
        return new Promise((resolve, reject) => {
            follow_ups.updateFromNotification( state.nextUrl, payload, rootState.axios).then(result => {
                if (!result.data.follow_up.completed) {
                    commit('setQuestion', result.data.follow_up)
                } else {

                }
                commit('notifications/showSuccess', {
                    title: i18n.t('success.UPDATE_FOLLOWUP_SUCCESS.title'), content: i18n.t('success.UPDATE_FOLLOWUP_SUCCESS.content')
                }, {root: true})
                resolve(result)
            }).catch(reason => {
                if (reason.response.data.status !== 'redirect') {
                    commit('notifications/showError', {
                        title: i18n.t('errors.UPDATE_FOLLOWUP_ERROR'), content: reason
                    }, {root: true})
                }
                reject(reason)
            })
        })
    },
    restartFollowUp({state, commit, rootState}, payload) {
        return new Promise((resolve, reject) => {
            follow_ups.restart(rootState.patients.selectedPatient.id, rootState.medical_cases.selectedMedicalCase.id, rootState.treatments.selectedTreatment.id, payload.followup_id, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: i18n.t('success.UPDATE_FOLLOWUP_SUCCESS.title'), content: i18n.t('success.UPDATE_FOLLOWUP_SUCCESS.content')
                }, {root: true})
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.UPDATE_FOLLOWUP_ERROR'), content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    viewResult({state, commit, rootState}) {
        return new Promise((resolve, reject) => {
            follow_ups.view(rootState.patients.selectedPatient.id, rootState.medical_cases.selectedMedicalCase.id, rootState.treatments.selectedTreatment.id, rootState.follow_ups.selectedFollowUp.id, rootState.axios).then(result => {
                commit('setFollowUp', result.data.results)
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.GET_FOLLOWUP_LOADING_ERROR'), content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    sendNotification({state, commit, rootState}) {
        return new Promise((resolve, reject) => {
            follow_ups.sendNotification(rootState.treatments.selectedTreatment.id, rootState.studies.selectedFollowUpDefinition.id, rootState.axios).then(result => {
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.GET_FOLLOWUP_LOADING_ERROR'), content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    exportResult({state, commit, rootState}) {
        return new Promise((resolve, reject) => {
            follow_ups.export(rootState.patients.selectedPatient.id, rootState.medical_cases.selectedMedicalCase.id, rootState.treatments.selectedTreatment.id, rootState.follow_ups.selectedFollowUp.id, rootState.axios).then(result => {
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.GET_FOLLOWUP_LOADING_ERROR'), content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    exportAllResults({state, commit, rootState}) {
        return new Promise((resolve, reject) => {
            follow_ups.fullExport(rootState.axios).then(result => {
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.GET_FOLLOWUP_LOADING_ERROR'), content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    exportDailyResults({state, commit, rootState}) {
        return new Promise((resolve, reject) => {
            follow_ups.dailyExport(rootState.axios).then(result => {
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.GET_FOLLOWUP_LOADING_ERROR'), content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    /*getTreatmentInfo({state, commit, rootState}) {
        return new Promise((resolve, reject) => {
            treatments.get(rootState.patients.selectedPatient.id, rootState.medical_cases.selectedMedicalCase.id, rootState.treatments.selectedTreatment.id, rootState.axios).then(result => {
                commit('setSelectedTreatment', result.data.treatment)
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.GET_TREATMENT_LOADING_ERROR'), content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },*/
}

// mutations
const mutations = {
    setQuestion(state, value) {
        state.selectedFollowUp.question = value
    },
    setSelectedFollowUpId(state, value) {
        state.selectedFollowUp.id = value
    },
    setCompleted(state, value) {
        state.selectedFollowUp.question.completed = value
    },
    setFollowUp(state, value) {
        state.resultFollowUp = value
    },
    setCompletedNextUrl(state, value) {
        state.completedNextUrl = value
    },
    setHasRelatedTreatmentWithFollowupDone(state, value) {
        state.hasRelatedTreatmentWithFollowupDone = value
    },
    setNextUrl(state, value) {
        state.nextUrl = value
    },
    setLastUrl(state, value) {
        state.lastUrl = value
    },
    setFollowUpStep(state, value) {
        state.followUpStep = value
    },
    setFollowUpName(state, value) {
        state.followUpName = value
    },
    setMedicalCaseName(state, value) {
        state.medicalCaseName = value
    },
    setFollowUpStatus(state, value) {
        state.followUpStatus = value
    },
    setConcern(state, value) {
        state.concern = value;
    },
    setCopyRelatedUrl(state, value) {
        state.copyRelatedUrl = value;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
